// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notification--info[data-v-7cab4de4] {\n  background-color: #1f2223;\n  color: #fff;\n  --magic-notification-icon-color: #fff;\n}\n.notification--message[data-v-7cab4de4] {\n  background-color: #1f2223;\n  --magic-primary: #fff;\n  --magic-button-primary-darker: var(--magic-button-light-darker);\n}\n\n.icon--close[data-v-7cab4de4] {\n  color: var(--magic-light, #fff);\n}", ""]);
// Exports
module.exports = exports;
